import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogClose } from '@angular/material/dialog';
import { ButtonComponent } from '@shared/components/button/button.component';
import { BUTTON_SIZE, BUTTON_TYPES } from '@shared/components/button/button-types.enum';

@Component({
  selector: 'app-mark-all-dialog',
  imports: [
    ButtonComponent,
    MatDialogClose,
  ],
  templateUrl: './mark-all-dialog.component.html',
  styleUrl: './mark-all-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarkAllDialogComponent {
  protected readonly BUTTON_SIZE = BUTTON_SIZE;
  protected readonly BUTTON_TYPES = BUTTON_TYPES;
}
